import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'ui-kit-filter-field',
    styleUrl: 'filter-field.component.scss',
    templateUrl: 'filter-field.component.html',
    standalone: false,
})
export class FilterFieldComponent {
    @Input({required: true}) label: string;
    @Input({required: true}) isFilterApplied: boolean;
    @Output() clearChange = new EventEmitter<void>();
    @Output() closedChange = new EventEmitter<void>();

    clear(event: MouseEvent): void {
        event.stopPropagation();
        this.clearChange.emit();
    }
}
